import styled from 'styled-components/native';
import {RFValue} from 'react-native-responsive-fontsize';
import {Platform} from 'react-native';

export const Wrapper = styled.TouchableOpacity`
  margin: ${RFValue(12)}px 24px;

  border-radius: ${RFValue(20)}px;
  ${({theme}) =>
    Platform.OS === 'ios'
      ? `
    shadow-color: ${theme.colors.carrinho_progress_shadow};
    shadow-offset: 0px 4px;
    shadow-opacity: 1;
    shadow-radius: 12px;
  `
      : `

  `}
`;

export const Background = styled.ImageBackground`
  border-radius: ${RFValue(20)}px;
  padding: ${RFValue(16)}px;
  border-width: 1px;
  border-color: ${({theme}) => theme.colors.carrinho_progress_border};
  overflow: hidden;
`;

export const TopRow = styled.View`
  flex-direction: row;
  align-items: center;
  gap: ${RFValue(12)}px;
`;

export const CarCol = styled.View`
  align-items: center;
  gap: ${RFValue(4)}px;
`;

export const CarImageWrapper = styled.View`
  width: ${RFValue(96)}px;
  height: ${RFValue(72)}px;
  align-items: center;
  justify-content: center;
`;

export const LevelBadge = styled.View`
  background-color: rgba(255, 149, 0, 1);
  padding: ${RFValue(2)}px ${RFValue(9)}px;
  border-radius: ${RFValue(20)}px;
  align-self: flex-end;
`;

export const LevelBadgeText = styled.Text`
  font-size: ${RFValue(9)}px;
  font-family: ${({theme}) => theme.fonts.bold};
  color: #fff;
`;

export const TitleCol = styled.View`
  flex: 1;
`;

export const TitleRow = styled.View`
  flex-direction: row;
  align-items: center;
  gap: ${RFValue(8)}px;
`;

export const FuelIconBox = styled.View`
  width: ${RFValue(28)}px;
  height: ${RFValue(28)}px;
  border-radius: ${RFValue(14)}px;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 149, 0, 0.12);
`;

export const Title = styled.Text`
  flex-shrink: 1;
  font-size: ${RFValue(15)}px;
  font-family: ${({theme}) => theme.fonts.bold};
  color: ${({theme}) => theme.colors.achievements_color};
`;

export const Subtitle = styled.Text`
  margin-top: ${RFValue(4)}px;
  font-size: ${RFValue(11)}px;
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.title};
`;

export const SubtitleBold = styled.Text`
  font-family: ${({theme}) => theme.fonts.bold};
  color: ${({theme}) => theme.colors.title};
`;

export const StatsRow = styled.View`
  flex-direction: row;
  gap: ${RFValue(8)}px;
  margin-top: ${RFValue(14)}px;
`;

export const StatCard = styled.View`
  flex: 1;
  flex-direction: row;
  align-items: center;
  gap: ${RFValue(6)}px;
  background-color: ${({theme}) => theme.colors.background};
  border-radius: ${RFValue(12)}px;
  padding: ${RFValue(8)}px;
  ${({theme}) =>
    Platform.OS === 'ios'
      ? `
    shadow-color: ${theme.colors.sutil_shadow};
    shadow-offset: 0px 2px;
    shadow-opacity: 1;
    shadow-radius: 4px;
  `
      : `

  `}
`;

export const StatIconCircle = styled.View`
  width: ${RFValue(26)}px;
  height: ${RFValue(26)}px;
  border-radius: ${RFValue(13)}px;
  align-items: center;
  justify-content: center;
  background-color: ${(props: {bg: string}) => props.bg};
`;

export const StatTextCol = styled.View`
  flex-shrink: 1;
`;

export const StatValue = styled.Text`
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.bold};
  color: ${({theme}) => theme.colors.title};

`;

export const StatLabel = styled.Text`
  font-size: ${RFValue(9)}px;
  font-family: ${({theme}) => theme.fonts.regular};
  color: ${({theme}) => theme.colors.text};
 
`;

export const FooterRow = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  margin-top: ${RFValue(12)}px;
  gap: ${RFValue(4)}px;
`;

export const FooterLink = styled.Text`
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
  color: rgba(255, 149, 0, 1);
`;
